import './product.scss';
import { ADD_TO_CART, BREAK_MOBILE, DISABLED, OFF, SOLD_OUT } from '../config/constants';
import addToCart from '../utils/addToCart';
import addClass from '../utils/dom/addClass';
import click from '../utils/dom/click';
import removeClass from '../utils/dom/removeClass';
import formatPrice, { isPriceZero } from '../utils/formatPrice';
import playVideo from '../utils/playVideo';
import preload from '../utils/preload';
import setupInquire from '../utils/setupInquire';

const ON = 'on';
let variant = window.VARIANT;
// let interval = null;

const turnOnButton = (button) => {
  removeClass(button, OFF);
  button.removeAttribute('aria-hidden');
};

const turnOffButton = (button) => {
  addClass(button, OFF);
  button.setAttribute('aria-hidden', 'true');
};

const updateUI = () => {
  const { VARIANTS } = window;
  const color = document.getElementById('product-color');
  const size = document.getElementById('product-size');
  const sku = document.getElementById('product-sku');
  const additionalOptions = Array.from(document.querySelectorAll('.product-select-option'));
  const dimensions = document.getElementById('product-dimensions');
  const urlParams = new URLSearchParams(window.location.search);
  const addToBagButton = document.querySelector('.add-to-bag-button');
  const comingSoon = document.querySelector('.coming-soon-button');
  const inquireButton = document.querySelector(`.inquire-button`);

  const colorIndex = color ? Number(color?.getAttribute('data-index')) : null;
  const colorValue = color?.value;
  const sizeIndex = size ? Number(size?.getAttribute('data-index')) : null;
  const sizeValue = size?.value;

  const optionLookup = [];
  if (colorIndex !== null) {
    optionLookup[colorIndex] = colorValue;
  }

  if (sizeIndex !== null) {
    optionLookup[sizeIndex] = sizeValue;
  }
  const firstColor = VARIANTS[0].color;
  const isSingleColor = VARIANTS.every((variant) => variant.color === firstColor);

  additionalOptions.forEach((option) => {
    const index = parseInt(option.getAttribute('data-index'), 10);
    const { value } = option;
    optionLookup[index] = value;
  });

  // Ignore the first element if it's a single color
  variant = VARIANTS.find((vari) => {
    return vari.options.every((value, index) => {
      if (isSingleColor && index === 0) {
        return true;
      }
      return value === optionLookup[index];
    });
  });

  const backgroundImage = document.querySelector('.product-media-image');
  if (variant.media?.backgroundImage) {
    backgroundImage.innerHTML = variant.media.backgroundImage;
  }

  if (sku) {
    sku.innerHTML = variant.sku;
  }

  if (dimensions) {
    dimensions.innerHTML = variant.dimensions;
  }

  // replace history state
  if (window.location.pathname !== 'blank') {
    urlParams.set('variant', variant.id);
    history.replaceState({}, '', `${location.pathname}?${urlParams.toString()}`);
  }

  if (!addToBagButton) {
    return variant;
  }

  const buttonPrice = addToBagButton.querySelector('.product-button-price');
  const productPrice = document.querySelector('.product-price');
  const formattedPrice = formatPrice(variant.price, variant.id);
  const newPrice = isPriceZero(formattedPrice)
    ? ''
    : `
  <span>
    ${formattedPrice}
  </span>`;

  const relatedProduct = document.querySelector('.related-product select');

  // Update the button prices
  const selectedValue = relatedProduct?.value || null;
  let formattedAdditionalPrice = '';
  if (selectedValue) {
    const parts = selectedValue.split('/');
    const relatedId = parseInt(parts[parts.length - 1], 10);
    const additionalPrice = formatPrice(variant.price, relatedId);
    formattedAdditionalPrice = isPriceZero(additionalPrice) ? '' : ` + ${additionalPrice}`;
  }
  const mainPriceDisplay = isPriceZero(formattedPrice) ? '' : formattedPrice;
  const newButtonPrice =
    mainPriceDisplay || formattedAdditionalPrice ? `<span>${mainPriceDisplay}${formattedAdditionalPrice}</span>` : '';
  buttonPrice.innerHTML = newButtonPrice;
  productPrice.innerHTML = newPrice;

  if (variant.comingsoon === 'true') {
    const date = comingSoon.querySelector('.product-release-date');
    date.innerHTML = variant.releaseDate ? variant.releaseDate : '';
    turnOnButton(comingSoon);
    turnOffButton(addToBagButton);
    turnOffButton(inquireButton);
  } else if (window.PRODUCT.inquiriesOnly) {
    turnOnButton(inquireButton);
    turnOffButton(addToBagButton);
    turnOffButton(comingSoon);
  } else {
    turnOnButton(addToBagButton);
    turnOffButton(comingSoon);
    turnOffButton(inquireButton);
  }

  if (variant.available && !variant.soldOut) {
    addToBagButton.removeAttribute(DISABLED);
    const addToCartLabel = window.PRODUCT?.metafields?.hmr?.add_to_cart_label || ADD_TO_CART;
    addToBagButton.querySelector('div').innerHTML = addToCartLabel;
  } else {
    addToBagButton.setAttribute(DISABLED, DISABLED);
    const backInStockLabel = window.PRODUCT?.metafields?.hmr?.back_in_stock_label || SOLD_OUT;
    addToBagButton.querySelector('div').innerHTML = backInStockLabel;
  }

  setupInquire(variant);

  return variant;
};

const changeColor = () => {
  const variant = updateUI();
  const currentImage = document.querySelector('.product-featured-image-image.on');
  const colorName = document.querySelector('.product-select-selected-color-name');
  const colorDot = document.querySelector('.product-select-selected-color');
  const value = variant.id;
  const newImage = document.getElementById(`image-${value}`);

  colorName.innerText = variant.color;
  colorDot.style.background = variant.colorHex;
  if (variant.color.toLowerCase() === 'alpine') {
    colorDot.style.border = '1px solid #000';
    colorName.style.color = '#000000';
  } else {
    colorDot.style.border = 'none';
    colorName.style.color = variant.colorHex;
  }

  const oldVariant = document.querySelector(`.explore-item.${OFF}`);
  if (oldVariant) {
    removeClass(oldVariant, OFF);
  }

  const newVariant = document.getElementById(`variant-${value}`);
  if (newVariant) {
    addClass(newVariant, OFF);
  }

  removeClass(document.querySelector(`.product-color.${ON}`), ON);
  addClass(document.getElementById(`swatch-${variant.color}`), ON);
  removeClass(currentImage, ON);
  addClass(newImage, ON);
};

const sizeChange = () => {
  updateUI();
};

// Setup the little color buttons
const setupColors = () => {
  const colorSelect = document.getElementById('product-color');
  if (!colorSelect) {
    return;
  }

  const radios = document.querySelectorAll('.product-color-radio');
  radios.forEach((radio) => {
    radio.addEventListener('click', (event) => {
      const { value } = event.target;
      const options = [...colorSelect.querySelectorAll('option')];
      const option = colorSelect.querySelector(`option[value="${value}"]`);

      colorSelect.selectedIndex = options.indexOf(option);

      changeColor(value);
    });
  });

  colorSelect.addEventListener('change', changeColor);
};

const setupRelatedProducts = () => {
  const relatedProduct = document.querySelector('.related-product');
  relatedProduct?.addEventListener('change', updateUI);
};

// Setup the size dropdown
const setupSizes = () => {
  const sizeSelect = document.getElementById('product-size');

  if (!sizeSelect) {
    return;
  }

  sizeSelect.addEventListener('change', sizeChange);
};

const setupAddToBag = () => {
  const relatedProduct = document.querySelector('.related-product');
  const addToBagButton = document.querySelector('.add-to-bag-button');

  if (!addToBagButton) {
    return;
  }

  addToBagButton.addEventListener(click(), async () => {
    await addToCart(addToBagButton, variant, relatedProduct);
  });
};

const setupSingleVariantProduct = () => {
  const variantId = document.getElementById('variant-id');
  if (!variantId) {
    return;
  }
};

const setupStones = () => {
  const rootClass = '.accordion';
  const triggerClass = 'accordion-button';
  const expanders = [...document.querySelectorAll(rootClass)];

  expanders.forEach((accordion) => {
    const expanded = 'aria-expanded';
    const controls = 'aria-controls';
    const disabled = 'aria-disabled';

    // Allow for multiple accordion sections to be expanded at the same time
    const allowMultiple = accordion.hasAttribute('data-allow-multiple');
    // Allow for each toggle to both open and close individually
    const allowToggle = allowMultiple ? allowMultiple : accordion.hasAttribute('data-allow-toggle');

    // Create the array of toggle elements for the accordion group
    const triggers = Array.prototype.slice.call(accordion.querySelectorAll(`.${triggerClass}`));
    // const panels = Array.prototype.slice.call(accordion.querySelectorAll('.expanders-answer'));

    accordion.addEventListener('click', (event) => {
      const { target } = event;

      if (target.classList.contains(triggerClass)) {
        // Check if the current toggle is expanded.
        const isExpanded = target.getAttribute(expanded) == 'true';
        const active = accordion.querySelector(`[${expanded}="true"]`);

        // without allowMultiple, close the open accordion
        if (!allowMultiple && active && active !== target) {
          // Set the expanded state on the triggering element
          active.setAttribute(expanded, 'false');
          // Hide the accordion sections, using aria-controls to specify the desired section
          document.getElementById(active.getAttribute(controls)).setAttribute('hidden', '');

          // When toggling is not allowed, clean up disabled state
          if (!allowToggle) {
            active.removeAttribute(disabled);
          }
        }

        if (!isExpanded) {
          // Set the expanded state on the triggering element
          target.setAttribute(expanded, 'true');
          // Hide the accordion sections, using aria-controls to specify the desired section
          document.getElementById(target.getAttribute(controls)).removeAttribute('hidden');

          // If toggling is not allowed, set disabled state on trigger
          if (!allowToggle) {
            target.setAttribute(disabled, 'true');
          }
        } else if (allowToggle) {
          // Set the expanded state on the triggering element
          target.setAttribute(expanded, 'false');
          // Hide the accordion sections, using aria-controls to specify the desired section
          document.getElementById(target.getAttribute(controls)).setAttribute('hidden', '');
        }

        event.preventDefault();
      }
    });

    // Bind keyboard behaviors on the main accordion container
    accordion.addEventListener('keydown', (event) => {
      const target = event.target;
      const key = event.which.toString();

      // const isExpanded = target.getAttribute(expanded) == 'true';
      // const allowToggle = (allowMultiple) ? allowMultiple : accordion.hasAttribute('data-allow-toggle');

      // 33 = Page Up, 34 = Page Down
      const ctrlModifier = event.ctrlKey && key.match(/33|34/);

      // Is this coming from an accordion header?
      if (target.classList.contains(triggerClass)) {
        // Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
        // 38 = Up, 40 = Down
        if (key.match(/38|40/) || ctrlModifier) {
          const index = triggers.indexOf(target);
          const direction = key.match(/34|40/) ? 1 : -1;
          const length = triggers.length;
          const newIndex = (index + length + direction) % length;

          triggers[newIndex].focus();

          event.preventDefault();
        } else if (key.match(/35|36/)) {
          // 35 = End, 36 = Home keyboard operations
          switch (key) {
            // Go to first accordion
            case '36':
              triggers[0].focus();
              break;
            // Go to last accordion
            case '35':
              triggers[triggers.length - 1].focus();
              break;
          }
          event.preventDefault();
        }
      }
    });

    // These are used to style the accordion when one of the buttons has focus
    accordion.querySelectorAll(`.${triggerClass}`).forEach(function (trigger) {
      trigger.addEventListener('focus', () => {
        addClass(accordion, 'focus');
      });

      trigger.addEventListener('blur', () => {
        removeClass(accordion, 'focus');
      });
    });

    // Minor setup: will set disabled state, via aria-disabled, to an
    // expanded/ active accordion which is not allowed to be toggled close
    if (!allowToggle) {
      // Get the first expanded/ active accordion
      const expandedCurrent = accordion.querySelector(`[${expanded}="true"]`);

      // If an expanded/ active accordion is found, disable
      if (expandedCurrent) {
        expandedCurrent.setAttribute('aria-disabled', 'true');
      }
    }
  });
};

const setupResize = () => {
  if (!document.querySelector('.product-details') || !document.querySelector('.product-media')) {
    setupAddToBag();
    setupInquire(variant);
    setupColors();
    setupSizes();
    setupStones();
    setupRelatedProducts();

    return;
  }

  const onResize = () => {
    const details = document.querySelector('.product-details');
    const media = document.querySelector('.product-media');
    const image = document.querySelector('.product-featured-image');
    const newDetails = details.cloneNode(true);
    const isMobile = window.innerWidth < BREAK_MOBILE;

    if (isMobile) {
      media.insertAdjacentElement('afterend', newDetails);
    } else {
      image.insertAdjacentElement('afterend', newDetails);
    }
    details.parentElement.removeChild(details);

    setupAddToBag();
    setupInquire(variant);

    const player = media.querySelector('.video-player');
    const diff = isMobile ? 28 : 160;
    const width = window.innerWidth - diff;

    player.style.width = `${width}px`;

    setupColors();
    setupSizes();
    setupStones();
    setupRelatedProducts();
  };

  let timerId;
  // Throttle function: Input as function which needs to be throttled and delay is the time interval in milliseconds
  const throttle = function (func, delay) {
    // If setTimeout is already scheduled, no need to do anything
    if (timerId) {
      return;
    }

    // Schedule a setTimeout after delay seconds
    timerId = setTimeout(function () {
      func();

      // Once setTimeout function execution is finished, timerId = undefined so that in <br>
      // the next scroll event function execution can be scheduled by the setTimeout
      timerId = undefined;
    }, delay);
  };

  window.addEventListener('resize', () => {
    throttle(onResize, 200);
  });
  onResize();
};

const setupPreload = () => {
  const images = [...document.querySelectorAll('.product-featured-image-image')];
  preload(images);
};

const decisionTree = () => {
  if (!window.PRODUCT.useDecisionTree) {
    return;
  }
  const select = document.querySelector('[data-decision-tree] select');

  if (!select) {
    return;
  }

  select.addEventListener('change', (event) => {
    document.querySelectorAll('[data-decision-tree-id]').forEach((el) => {
      el.setAttribute('hidden', 'true');
    });
    const target = document.querySelector(`[data-decision-tree-id="select-${event.target.value}"]`);
    if (!target) {
      return;
    }
    target.removeAttribute('hidden');
  });

  const onChange = (event) => {
    const addToBagButton = document.querySelector('.add-to-bag-button');
    const variant = window.VARIANTS.find(
      (variant) => variant.options[1] === select.value && variant.options[2] === event.target.value,
    );
    if (variant) {
      addToBagButton.removeAttribute(DISABLED);
      addToBagButton.addEventListener(click(), async () => {
        await addToCart(addToBagButton, variant);
      });
    } else {
      addToBagButton.setAttribute(DISABLED, DISABLED);
    }
  };

  document.querySelectorAll('[data-decision-tree-id]').forEach((el) => {
    el.addEventListener('change', onChange);
  });
};

const setupAdditionalOptions = () => {
  const options = Array.from(document.querySelectorAll('.product-select-option'));
  if (options.length === 0) {
    return;
  }
  options.forEach((option) => {
    option.addEventListener('change', updateUI);
  });
};

const preloadQueue = new Set();
const preloadImage = () => {
  if (preloadQueue.size === 0) {
    return;
  }

  const div = document.createElement('div');
  const image = preloadQueue.values().next().value;
  div.innerHTML = image;
  const img = div.querySelector('img');
  img.style.display = 'block';
  img.style.height = 'auto';
  img.style.width = '100vw';
  img.style.position = 'absolute';
  img.style.opacity = '0';
  img.style.pointerEvents = 'none';
  img.style.zIndex = '-1';
  img.style.top = '0';
  img.style.left = '0';
  img.onload = () => {
    preloadQueue.delete(image);
    preloadImage();
  };
  img.setAttribute('loading', 'eager');
  document.body.appendChild(img);
};

const preloadVariantBackgroundImages = () => {
  const { VARIANTS } = window;
  for (const key in Object.entries(VARIANTS)) {
    const variant = VARIANTS[key];
    if (!variant.media?.backgroundImage) {
      continue;
    }
    preloadQueue.add(variant.media.backgroundImage);
  }

  preloadImage();
};

const productNav = () => {
  const productNav = document.getElementById('product-group-select');

  if (!productNav) {
    return;
  }
  productNav.addEventListener('change', (event) => {
    window.location.href = event.target.value;
  });

  // preload the URLs of the values of the select using prefetch
  const options = productNav.querySelectorAll('option');
  for (const option of options) {
    // Only prefetch valid URLs
    if (option.value && option.value !== '#') {
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = option.value;
      link.as = 'document';
      link.onload = () => {
        option.setAttribute('data-preload', 'true');
      };
      link.onerror = (error) => {
        console.error('Error prefetching URL:', option.value, error);
      };
      document.head.appendChild(link);
    }
  }
};

const product = async () => {
  setupResize();
  setupSingleVariantProduct();
  setupPreload();
  decisionTree();
  setupAdditionalOptions();
  playVideo(updateUI());
  productNav();
  preloadVariantBackgroundImages();
};

product();
